// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fe42263f","453":"a5b71f5f","455":"618bcac5","977":"4099b5ee"}[chunkId] + ".chunk.js";
};